import {User} from '@drl/core/auth/models/user.model';

import {MessageRecipient} from './message-recipient.model';

export class ChatMessage {
  id?: string;
  subject?: string;
  body: string;
  status?: number;
  expireOn?: string;
  patientUserId: number;
  toUserId?: number;
  channelId?: string;
  channelKey?: string;
  categoryId?: number;
  parentId?: string;
  parent?: ChatMessage;
  contentId?: string;
  contentUrl?: string;
  createdBy?: number;
  sender?: User;
  createdOn?: Date;
  messageRecipients?: MessageRecipient[];
  displayTitle?: string;
}
